import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Image } from "../../models/image";
import { faCloudUploadAlt, faTrash } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-circle-image-input',
    templateUrl: './circle-image-input.component.html',
    styleUrls: ['./circle-image-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CircleImageInputComponent {

  faCloudUploadAlt = faCloudUploadAlt;
  faTrash = faTrash;

  @Input()
  defaultSrc:string = null;

  @Input()
  set src(src: string) {
    this.image.current = src || this.defaultSrc;
  }

  @Output()
  update = new EventEmitter();

  @Output()
  delete = new EventEmitter();

  image = new Image();

  constructor() {
  }

  updateImage(event) {
    const that = this;
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      this.image.file = event.target.files[0];

      reader.onload = (e) => {
        that.image.current = e.target.result as string;
        this.update.emit(that.image);
      };
      reader.readAsDataURL(this.image.file);
    }
  }

  deleteImage() {
    this.image.current = this.defaultSrc;
    this.delete.emit(this.image);
  }
}
